import { useMutation, useQueryClient } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import axios from "axios";
import toast from "react-hot-toast";
import { brandApi } from "../../../assets/apis";
import {
  setSiderBarActiveLink,
  setSiderBarActiveList,
} from "../../../redux-store/sidebarActiveList";
import { useDispatch } from "react-redux";
const AddBrand = () => {
  const [addBrand, setAddBrand] = useState({ active: true });
  const [apiInProccess, setApiInProccess] = useState(false);

  const dispatch = useDispatch();
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setAddBrand((pre) => ({
      ...pre,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleInputChangeWithCondition = (e, validationRegex) => {
    const { name, value } = e.target;
    if (value === "" || validationRegex.test(value)) {
      setAddBrand((prev) => ({ ...prev, [name]: value }));
    }
  };

  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (data) => {
      return axios.post(brandApi, data);
    },
    onSuccess: () => {
      setApiInProccess(false);
      queryClient.invalidateQueries(["brand"]);
      toast.success("Brand saved successfully!");
      navigate("/brand");
    },
    onError: (error) => {
      setApiInProccess(false);
      const errorMessage = error.response?.data?.message;
      toast.error(` ${errorMessage}`);
    },
  });

  const handleSaveBrand = (e) => {
    e.preventDefault();
    const { name, description } = addBrand;
    let updatedBrandData = {
      ...addBrand,
      name: name.trim(),
      ...(description && { description: description.trim() }),
    };
    setAddBrand(updatedBrandData);
    if (!updatedBrandData.name) return toast.error("Please enter brand name");
    setApiInProccess(true);

    mutation.mutate(updatedBrandData);
  };

  useEffect(() => {
    dispatch(setSiderBarActiveList({ name: "Items" }));
    dispatch(setSiderBarActiveLink({ link: "brand" }));
  }, []);
  return (
    <div className={`main-panel`}>
      <div className="content-wrapper">
        <div className="row">
          <div className="col-sm-12">
            <div className="d-flex justify-content-between m-1 p-1 align-items-baseline ">
              <h3 className="ukhd mb-3">Add Brand</h3>
              <button
                type="button"
                className="btn btn-warning btn-sm"
                onClick={() => navigate("/brand")}
              >
                <div className="d-flex justify-content-center">
                  <i className="mdi mdi mdi-keyboard-backspace"></i>
                  <span>Back</span>
                </div>
              </button>
            </div>
            <div className="row flex-grow">
              <div className="col-lg-12 grid-margin stretch-card">
                <div className="card card-rounded">
                  <div className="card-body">
                    <div className="col-lg-12">
                      <div className="col-lg-12 ">
                        <h5>BRAND INFORMATION</h5>
                      </div>
                      <form onSubmit={handleSaveBrand}>
                        <div className="col-lg-4 mt-4">
                          <label>Name</label>
                          <input
                            type="text"
                            name="name"
                            className="form-control"
                            placeholder="Brand"
                            required
                            value={addBrand.name || ""}
                            onChange={(e) =>
                              handleInputChangeWithCondition(
                                e,
                                /^[\s\S]*$/
                              )
                            }
                          />
                        </div>
                        <div className="col-lg-6 mt-4">
                          <label>Active ? </label>{" "}
                          <input
                            type="checkbox"
                            name="active"
                            checked={!!addBrand.active}
                            onChange={handleInputChange}
                          />
                        </div>
                        <div className="col-lg-9 mt-4">
                          <label
                            className="form-control-label"
                            htmlFor="input-address"
                          >
                            Description
                          </label>
                          <textarea
                            className="form-control form-control-alternative"
                            rows="7"
                            style={{
                              borderRadius: "5px",
                              resize: "none",
                              minHeight: "80px",
                            }}
                            name="description"
                            value={addBrand.description || ""}
                            onChange={handleInputChange}
                          />
                        </div>
                        <div className="col-lg-9 mt-2">
                          <button
                            type="submit"
                            className="btn btn-primary d-flex justify-content-center px-3 py-2"
                            disabled={apiInProccess}
                          >
                            <i className="mdi mdi-content-save me-1"></i> Save
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddBrand;
